import { render, staticRenderFns } from "./LegislationRevisionHistory.vue?vue&type=template&id=2807249f&scoped=true&"
import script from "./LegislationRevisionHistory.vue?vue&type=script&lang=ts&"
export * from "./LegislationRevisionHistory.vue?vue&type=script&lang=ts&"
import style0 from "./LegislationRevisionHistory.vue?vue&type=style&index=0&id=2807249f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2807249f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VSimpleTable})
